





































import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      myPic: require('../../assets/mypic.webp'),
    }
  },
})
